import { html, nothing, type TemplateResult } from 'lit';
import { statusBadge } from '@vitesse/base-ui/components/templates';

/** The 4 per-NIC IPs a box may report — a structural subset of FleetGateway, so a
 *  FleetGateway is assignable here without a copy. */
export interface GatewayNetwork {
  itIp: string;
  otIp: string;
  wifiIp: string;
  publicIp: string;
}

/** The box's network-IP badges — IT (ethernet-port), OT (factory), WiFi (wifi),
 *  public (globe-lock) — each rendered ONLY when that IP is known. The role icon
 *  says which network; the label is the IP. Shared verbatim by the gateway card
 *  (vitesse-home) and the gateway detail page so the two never drift. */
export function gatewayNetBadges(net: GatewayNetwork | undefined): TemplateResult {
  if (!net) return html``;
  const b = (ip: string, icon: string) => (ip ? statusBadge('gray', ip, icon) : nothing);
  return html`${b(net.itIp, 'ethernet-port')}${b(net.otIp, 'factory')}${b(net.wifiIp, 'wifi')}${b(net.publicIp, 'globe-lock')}`;
}
